import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isPathCurrent } from '../SysadminSPA/shared/ProgramTree/contentPages';
import { RailLinkProps, railLinkState } from '../SysadminSPA/shared/ProgramTree/RailLink';

// Rail pages carry their SPA route in `to`; on this mount the same pages live under /admin/programs
// at the Rails URLs, so those routes are translated and become router links. Anything else stays
// a plain anchor, as on the legacy content rail.
export const legacyMountPath = (to: string) => {
  const lessons = to.match(/^\/content\/programs\/(\d+)$/);
  if (lessons) return `/${lessons[1]}/lessons`;

  const program = to.match(/^\/content\/programs\/(.+)$/);
  if (program) return `/${program[1]}`;

  return to.replace(/^\/content/, '') || '/';
};

const LegacyMountRailLink = ({ children, ...props }: RailLinkProps) => {
  const { pathname } = useLocation();
  const { page } = props;

  if (page.to) {
    const to = legacyMountPath(page.to);
    const active = props.active ?? isPathCurrent(to, pathname, page.matchNested);
    const { className, current } = railLinkState({ ...props, active });
    return (
      <Link aria-current={current} className={className} to={to}>
        {children}
      </Link>
    );
  }

  const { className, current } = railLinkState(props);
  return (
    <a aria-current={current} className={className} data-method={page.method} href={page.href}>
      {children}
    </a>
  );
};

export default LegacyMountRailLink;
